// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable */
import 'babel-polyfill';
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { scrollToptimer } from '@/common/utils/'
import './style/theme/index.css';
import './style/font/iconfont.css'
import App from './App';
import router from './router';
import { urls, axios, store } from '@/common/index';
import Cookies from 'js-cookie';
import qs from 'qs';
import VueClipboard  from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload';
import VueAnalytics from 'vue-analytics'
import i18n from './i18n/i18n'
import Vuetify from 'vuetify'

Vue.use(VueLazyload);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(Vuetify);
Vue.config.productionTip = false;
Vue.prototype.$api = axios;
Vue.prototype.$urls = urls;
Vue.prototype.$qs = qs;
Vue.prototype.$Cookies = Cookies;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
});

// 当路由跳转页面后,返回顶部
router.afterEach((to,from,next) =>{
  scrollToptimer()
})

// 加入百度统计
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})



// WEBPACK FOOTER //
// ./src/pages/build902/build902.js